import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.css";
import {App as AntApp, ConfigProvider} from "antd";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store, {persistor} from "./redux/store";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {COLORS, FONTS, RADIUS} from "./designSystem";
import AntdFeedbackBridge from "./utils/AntdFeedbackBridge";

/**
 * antd's palette, set once. Under v4 this lived in craco's Less `modifyVars`; v6 styles
 * itself with CSS-in-JS, so the theme is configured here instead and the brand tokens come
 * from the design system rather than being restated as literals.
 */
const theme = {
  token: {
    colorPrimary: COLORS.brand,
    colorSuccess: COLORS.success,
    colorWarning: COLORS.warning,
    colorError: COLORS.danger,
    colorText: COLORS.text,
    colorTextSecondary: COLORS.textMuted,
    colorBorderSecondary: COLORS.cardBorder,
    borderRadius: RADIUS.lg,
    fontFamily: FONTS.sans,
  },
};

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ConfigProvider theme={theme}>
                    {/*
                      antd's App supplies the context its message/notification/modal helpers
                      need to see the theme. The bridge republishes those instances so the
                      app's plain callbacks can raise themed toasts without becoming hooks.
                    */}
                    <AntApp>
                        <AntdFeedbackBridge/>
                        <App/>
                    </AntApp>
                </ConfigProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
